<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
  components: {
    highcharts: Chart,
  },
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(Project) {
        this.$store.dispatch('setProjects', Project);
      },
    },
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    calcRetvTermWise() {
      let result = [];
      // if (project.schema.inputs.step1.locationObj && project.schema.inputs.step2.summary_step2.surface_area_wall && project.schema.inputs.retv6A.summary_retv6A.term_1_total) {
      let seriesData = [(this.schema.inputs.retv6A.summary_retv6A.term_1_total / this.schema.inputs.step2.summary_step2.surface_area_wall) * this.schema.inputs.step1.locationObj.a, (this.schema.inputs.retv6B.summary_retv6B.term_2_total / this.schema.inputs.step2.summary_step2.surface_area_wall) * this.schema.inputs.step1.locationObj.b, (this.schema.inputs.retv6C.term_3_total / this.schema.inputs.step2.summary_step2.surface_area_wall) * this.schema.inputs.step1.locationObj.c];
      result.push({
        type: 'column',
        name: this.schema.inputs.step1.project_name,
        // color: '#03bbd4',
        data: seriesData,
        // }
      });
      return result;
    },
    chartOptions() {
      return {
        chart: {
          type: 'column',
          height: 300,
          width: 300,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Term wise RETV visualization',
        },
        xAxis: {
          categories: ['RETV term 1', 'RETV term 2', 'RETV term 3'],
        },
        yAxis: {
          title: {
            text: 'RETV (W/m2)',
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          column: {
            minPointLength: 4,
          },
        },
        series: this.calcRetvTermWise,
      };
    },
  },
};
</script>

<style></style>
